const WIDTH_PANEL = 350;
const HEIGHT_HEADER = 64;

export const calculateScatterPlotDimensions = (showRightPanel: boolean) => {
  const width =
    window.innerWidth - (showRightPanel ? WIDTH_PANEL * 2 : WIDTH_PANEL);
  const height = window.innerHeight - HEIGHT_HEADER;

  return {
    width,
    height,
  };
};

export const calculateHistogramDimensions = (graphWidth: number = 800) => {
  return {
    width: graphWidth * 0.8,
  };
};
